import { gql } from '../../utils/GraphQLUtil';

export default gql`
  query($input: SuggestJurisdictionsInput!) {
    suggestJurisdictions(input: $input) {
      gmapsApiKey
      gmapsBoundaryMapId
      matchedJurisdiction {
        id
        city {
          id
          name
          slug
          noLicensing
          addressValidation
          jurisdictions {
            id
            name
            jurisdictionInformation
          }
        }
        jurisdictionInformation
        adminHasAccess
        displayName
        name
        color
      }
      suggestions {
        id
        city {
          id
          name
          slug
          noLicensing
          addressValidation
          jurisdictions {
            id
            name
          }
        }
        jurisdictionInformation
        adminHasAccess
        displayName
        name
        color
      }
      headingHtml
      suggestionTerms
      nonLicensingFallbackJurisdiction {
        id
        city {
          id
          name
          slug
          noLicensing
          addressValidation
          jurisdictions {
            id
            name
          }
        }
        adminHasAccess
        displayName
        name
        jurisdictionInformation
        color
      }
      nonLicensingHtml
      nonLicensingLearnMoreHtml
      nonLicensingFallbackOptionLabel
      jurisdictionBoundaries {
        includedBoundaries {
          fillColor
          strokeColor
          externalSourceId
          externalSource
          externalSourceLayer
          name
          jurisdictionId
        }
        excludedBoundaries {
          fillColor
          strokeColor
          externalSourceId
          externalSource
          externalSourceLayer
          name
          jurisdictionId
        }
      }
    }
  }
`;
